import { render, staticRenderFns } from "./PrjConfig.vue?vue&type=template&id=32b6c4ad&"
import script from "./PrjConfig.vue?vue&type=script&lang=ts&"
export * from "./PrjConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports